import { CONFIG_UPDATE } from 'Reducers/config/types';
import { generateUserAgentHeader, urls } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';

const getConfig = async (
  compatibility: boolean,
  country: string,
  appVersion?: string,
  deviceManufacturer?: string,
  deviceModel?: string,
  osType?: string,
  osVersion?: string
) => {
  const result = await mediator.request<ApiResponse<Config>>('api:invoke', {
    method: 'GET',
    url: `${urls.apiUrl}config`,
    headers: {
      'X-User-Agent': generateUserAgentHeader('clm', appVersion, osType, osVersion),
    },
    params: {
      country,
      compatibility,
      deviceManufacturer,
      deviceModel,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};

export const updateConfig = async (
  compatibility: boolean,
  country = 'US',
  appVersion?: string,
  deviceManufacturer = 'none',
  deviceModel = 'none',
  osType?: string,
  osVersion?: string
) => {
  const config = await getConfig(
    compatibility,
    country,
    appVersion,
    deviceManufacturer,
    deviceModel,
    osType,
    osVersion
  );

  store.dispatch({ type: CONFIG_UPDATE, config });
};
